import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-prompt-modal',
  templateUrl: './prompt-modal.component.html',
  styleUrls: ['./prompt-modal.component.scss'],
  standalone: false
})
export class PromptModalComponent {
  @Input() open: boolean = false;
  @Input() backdropDismiss: boolean = true;
  @Input() title: string = '';
  @Input() message: string = '';
  @Input({ transform: (value: string) => [value] }) confirmHref!: string[];
  @Input() confirmLabel: string = 'Continue';
  @Input() invert: boolean = false;
  @Output() dismiss = new EventEmitter<any>();
  @Output() confirm = new EventEmitter<any>();

  constructor(private router: Router) { }

  onCancel() {
    this.dismiss?.emit();
  }

  onConfirm() {
    if (this.confirmHref) this.router.navigate(this.confirmHref);
    else this.confirm?.emit();
  }
}
